export default __webpack_public_path__ + "static/012-19052b7d0b06dd13e04c0ce5c05b04b6.jpg";